const processingByChatId = new Map<string, boolean>();
const listeners = new Set<() => void>();

function emit() {
  for (const cb of listeners) cb();
}

export function setAgentChatProcessingFlag(chatId: string, processing: boolean): void {
  const id = chatId.trim();
  if (!id) return;
  const was = Boolean(processingByChatId.get(id));
  if (processing) {
    if (was) return;
    processingByChatId.set(id, true);
  } else {
    if (!was) return;
    processingByChatId.delete(id);
  }
  emit();
}

export function getAgentChatProcessingFlag(chatId: string): boolean {
  return Boolean(processingByChatId.get(chatId.trim()));
}

export function getAnyAgentChatProcessing(): boolean {
  for (const v of processingByChatId.values()) {
    if (v) return true;
  }
  return false;
}

export function subscribeAgentChatsProcessing(onChange: () => void): () => void {
  listeners.add(onChange);
  return () => listeners.delete(onChange);
}

export function resetAgentChatsProcessingStore(): void {
  processingByChatId.clear();
  listeners.clear();
}
